import { Badge, BadgeProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

const COLORS: Record<string, BadgeProps["color"]> = {
  DRIVER_FAULT:   "red",
  CUSTOMER_FAULT: "orange",
  EXTERNAL:       "yellow",
  SYSTEM_ERROR:   "grape",
  UNDETERMINED:   "gray",
}

const VARIANTS: Record<string, BadgeProps["variant"]> = {
  DRIVER_FAULT:   "filled",
  CUSTOMER_FAULT: "filled",
  EXTERNAL:       "filled",
  SYSTEM_ERROR:   "filled",
  UNDETERMINED:   "outline",
}

interface Props {
  attribution: string | null | undefined
  size?: BadgeProps["size"]
}

export function AttributionBadge({ attribution, size = "sm" }: Props) {
  const { t } = useTranslation("delivery")
  if (!attribution) {
    return (
      <Badge size={size} variant="light" color="gray">
        —
      </Badge>
    )
  }

  return (
    <Badge
      size={size}
      variant={VARIANTS[attribution] ?? "filled"}
      color={COLORS[attribution] ?? "gray"}
    >
      {t(`failed.attribution.${attribution}`, { defaultValue: attribution })}
    </Badge>
  )
}
